export const LDO = {
	ORDERABLE_PART_NUMBER: { mappingName: 'orderable_part_number', formattedHeading: 'OPN' },
	GENERAL_PART_NUMBER: { mappingName: 'general_part_number', formattedHeading: 'WPN' },
	PRICE: { mappingName: 'price', formattedHeading: 'Price' },
	RTM: { mappingName: 'rtm', formattedHeading: 'RTM' },
	NO_OUTPUTS: { mappingName: 'no_outputs', formattedHeading: 'Outputs' },
	VOUT_MIN_V: { mappingName: 'vout_min_V', formattedHeading: 'V<sub>OUT<sub>(min)</sub></sub>' },
	VOUT_MAX_V: { mappingName: 'vout_max_V', formattedHeading: 'V<sub>OUT<sub>(max)</sub></sub>' },
	VDROP_V: { mappingName: 'vdrop_V', formattedHeading: 'V<sub>DROP<sub>(max)</sub></sub>' },
	VIN_MIN_V: { mappingName: 'vin_min_V', formattedHeading: 'V<sub>IN<sub>(min)</sub></sub>' },
	VIN_MAX_V: { mappingName: 'vin_max_V', formattedHeading: 'V<sub>IN<sub>(max)</sub></sub>' },
	IOUT_TYP_A: { mappingName: 'iout_typ_A', formattedHeading: 'I<sub>OUT<sub>(typ)</sub></sub>' },
	IQ_TYP_MA: { mappingName: 'iq_typ_mA', formattedHeading: 'I<sub>Q<sub>(typ)</sub></sub>' },
	VREF_TYP_V: { mappingName: 'vref_typ_V', formattedHeading: 'V<sub>REF<sub>(typ)</sub></sub>' },
	IADJ_UA: { mappingName: 'iadj_uA', formattedHeading: 'I<sub>ADJ</sub>' },
	IDISABLE_UA: { mappingName: 'idisable_uA', formattedHeading: 'I<sub>Standby<sub>(max)</sub></sub>' },
	PSRR_DB: { mappingName: 'psrr_db', formattedHeading: 'PSRR' },
	FRQ_PSSR_KHZ: { mappingName: 'frq_pssr_kHz', formattedHeading: 'f<sub> @ PSRR</sub>' },
	IG_MA: { mappingName: 'ig_mA', formattedHeading: 'I<sub>GND @ I<sub>OUT (max)</sub></sub>' },
	REG_LOAD_MAX_MV: { mappingName: 'reg_load_max_mV', formattedHeading: 'Reg<sub>LOAD<sub>(max)</sub></sub>' },
	REG_LOAD_MAX_PERCENTOFV: {
		mappingName: 'reg_load_max_percentOfV',
		formattedHeading: 'Reg<sub>LINE<sub>(max)</sub></sub>'
	},
	RTHJA_CW: { mappingName: 'rthja_CW', formattedHeading: 'R<sub>Θja</sub>' },
	RTHJC_CW: { mappingName: 'rthjc_CW', formattedHeading: 'R<sub>Θjc</sub>' },
	T_MAX_C: { mappingName: 't_max_C', formattedHeading: 'T<sub>j<sub>(max)</sub></sub>' },
	T_OPR_MAX_C: { mappingName: 't_opr_max_C', formattedHeading: 'T<sub>A<sub>(max)</sub></sub>' },
	T_OPR_MIN_C: { mappingName: 't_opr_min_C', formattedHeading: 'T<sub>A<sub>(min)</sub></sub>' },
	VOUT_ACCURANCY_MAX_MV: {
		mappingName: 'vout_accurancy_max_mV',
		formattedHeading: 'V<sub>OUT<sub>Accurancy(max)</sub></sub>'
	},
	VREF_ACCURANCY_MAX_PERCENT: {
		mappingName: 'vref_accurancy_max_percent',
		formattedHeading: 'V<sub>REF<sub>Accurancy(max)</sub></sub>'
	},
	TEMP_SHUT_TYP: { mappingName: 'temp_shut_typ', formattedHeading: 'T<sub>SHUTDOWN<sub>(typ)</sub></sub>' },
	TEMP_SHUT_HYS: { mappingName: 'temp_shut_hys', formattedHeading: 'T<sub>SHUTDOWN<sub>(hys)</sub></sub>' },
	I_SHUT_TYP: { mappingName: 'i_shut_typ', formattedHeading: 'I<sub>SHUTDOWN<sub>(typ)</sub></sub>' },
	NOISE_VOUT_MULTIPLIER: {
		mappingName: 'noise_vout_multiplier',
		formattedHeading: 'V<sub>OUT<sub>Noise Multiplier</sub></sub>'
	},
	V_NOISE_RMS_UV: { mappingName: 'v_noise_rms_uV', formattedHeading: 'V<sub>OUT<sub>Noise</sub></sub>' },
	ENABLE: { mappingName: 'enable', formattedHeading: 'Enable' },
	POWER_GOOD: { mappingName: 'power_good', formattedHeading: 'Power Good' },
	SOFT_START: { mappingName: 'soft_start', formattedHeading: 'Soft Start' },
	DISCHG_OP: { mappingName: 'dischg_op', formattedHeading: 'Active Discharge' },
	VCC_TYP_V: { mappingName: 'vcc_typ_V', formattedHeading: 'V<sub>CC<sub>(typ)</sub></sub>' },
	IBIAS_UA: { mappingName: 'ibias_uA', formattedHeading: 'I<sub>Bias</sub>' },
	AUTO_APP: { mappingName: 'auto_app', formattedHeading: 'AEC Qualified' },
	REVERSE_BATTERY_PROTECTION: {
		mappingName: 'reverse_battery_protection',
		formattedHeading: 'Reverse Pole Protection'
	},
	LOAD_DUMP: { mappingName: 'load_dump', formattedHeading: 'Load Dump Protection' },
	I_LIM_ADJ: { mappingName: 'i_lim_adj', formattedHeading: 'I<sub>Lim<sub>(Adj)</sub></sub>' },
	CTRL_PIN_OP: { mappingName: 'ctrl_pin_op', formattedHeading: 'Control Pin' },
	I2C_BUS: { mappingName: 'i2c_bus', formattedHeading: 'I<sup>2</sup>C Bus' },
	PASS_TYPE: { mappingName: 'pass_type', formattedHeading: 'Pass Transistor Type' },

	//NOTE: { mappingName: Unit conversion is not available for SLEW_RATE_VOUT_MV_US, formattedHeading: '' },
	// this parameter is returned without conversion, formattedHeading: '' }, please leave unitPrefix empty in pageDefinition
	SLEW_RATE_VOUT_MV_US: {
		mappingName: 'slew_rate_vout_mV_us',
		formattedHeading: 'V<sub>OUT<sub>Slew Rate</sub></sub>'
	},

	I_EN_UA: { mappingName: 'i_en_uA', formattedHeading: 'I<sub>Standby<sub>(typ)</sub></sub>' },
	VDROP_TYP_V: { mappingName: 'vdrop_typ_V', formattedHeading: 'V<sub>DROP<sub>(typ)</sub></sub>' },
	VOUT_ACCURANCY_MIN_MV: {
		mappingName: 'vout_accurancy_min_mV',
		formattedHeading: 'V<sub>OUT<sub>Accurancy(min)</sub></sub>'
	},
	IOUT_MAX_A: { mappingName: 'iout_max_A', formattedHeading: 'I<sub>OUT<sub>(max)</sub></sub>' },
	IOUT_MIN_A: { mappingName: 'iout_min_A', formattedHeading: 'I<sub>OUT<sub>(min)</sub></sub>' },
	RDIS_OHM: { mappingName: 'rdis_ohm', formattedHeading: '' },
	VEN_THRHD_HIGH_V: { mappingName: 'ven_thrhd_high_V', formattedHeading: 'V<sub>EN<sub>(high)</sub></sub>' },
	VEN_THRHD_LOW_V: { mappingName: 'ven_thrhd_low_V', formattedHeading: 'V<sub>EN<sub>(low)</sub></sub>' },
	DESCRIPTION: { mappingName: 'description', formattedHeading: 'Description' },
	INPUT_VOL_OK: { mappingName: 'Input_Vol_ok', formattedHeading: 'V<sub>IN<sub>OK</sub></sub>' },
	OUTPUT_VOL_OK: { mappingName: 'Output_Vol_ok', formattedHeading: 'V<sub>OUT<sub>OK</sub></sub>' },
	OUTPUT_CUR_OK: { mappingName: 'Output_Cur_ok', formattedHeading: 'I<sub>OUT<sub>OK</sub></sub>' },
	MINTEMP_OK: { mappingName: 'minTemp_ok', formattedHeading: 'T<sub>(min)<sub>OK</sub></sub>' },
	VDROP_OK: { mappingName: 'Vdrop_ok', formattedHeading: 'V<sub>DROP<sub>OK</sub></sub>' },
	ELE_QULIFIED_IC: { mappingName: 'ele_qulified_IC', formattedHeading: '' },
	DATASHEET_FILE_NAME: { mappingName: 'datasheet_file_name', formattedHeading: '' },
	ENABLED: { mappingName: 'enabled', formattedHeading: 'Enabled' },
	STATUS: { mappingName: 'status', formattedHeading: 'Status' },
	COMPLETED: { mappingName: 'completed', formattedHeading: 'Completed' },
	COUT_MIN_UF: { mappingName: 'cout_min_uf', formattedHeading: 'C<sub>OUT<sub>(min)</sub></sub>' },
	COUT_MAX_UF: { mappingName: 'cout_max_uf', formattedHeading: 'C<sub>OUT<sub>(max)</sub></sub>' },
	ESR_MIN_COUT_MOHMS: { mappingName: 'esr_min_cout_mohms', formattedHeading: 'ESR<sub>OUT<sub>(min)</sub></sub>' },
	ESR_MAX_COUT_MOHMS: { mappingName: 'esr_max_cout_mohms', formattedHeading: 'ESR<sub>OUT<sub>(max)</sub></sub>' },
	COUT_TECHNOLOGIES: { mappingName: 'cout_technologies', formattedHeading: 'C<sub>OUT<sub>Technologies</sub></sub>' },
	CIN_MIN_UF: { mappingName: 'cin_min_uf', formattedHeading: 'C<sub>IN<sub>(min)</sub></sub>' },
	CIN_MAX_UF: { mappingName: 'cin_max_uf', formattedHeading: 'C<sub>IN<sub>(max)</sub></sub>' },
	CIN_TECHNOLOGIES: { mappingName: 'cin_technologies', formattedHeading: 'C<sub>IN<sub>Technologies</sub></sub>' },
	CBIAS_MIN_UF: { mappingName: 'cbias_min_uf', formattedHeading: 'C<sub>BIAS<sub>(min)</sub></sub>' },
	FLOAT_IOUT_MIN_MA: { mappingName: 'float_iout_min_mA', formattedHeading: 'I<sub>BIAS<sub>FLOATING</sub></sub>' },
	CFF_MIN_UF: { mappingName: 'cff_min_uf', formattedHeading: 'C<sub>FF<sub>(min)</sub></sub>' },
	LONG_DESCRIPTION: { mappingName: 'long_description', formattedHeading: '' },
	EVALUATION_BOARD_OPN: { mappingName: 'evaluation_board_opn', formattedHeading: '' },
	CASE_OUTLINE_FILE_NAME: { mappingName: 'case_outline_file_name', formattedHeading: '' }
};

export const FLYBACK = {
	PART_NUMBER: { mappingName: 'part_number', formattedHeading: '' },
	RTM: { mappingName: 'rtm', formattedHeading: '' },
	INTG_SWITCH_TYPE: { mappingName: 'intg_switch_type', formattedHeading: '' },
	VHV_MAX_V: { mappingName: 'vhv_max_V', formattedHeading: '' },
	VHV_MIN_V: { mappingName: 'vhv_min_V', formattedHeading: '' },
	IHV_TYP_UA: { mappingName: 'ihv_typ_uA', formattedHeading: '' },
	VCC_MAX_V: { mappingName: 'vcc_max_V', formattedHeading: '' },
	VCC_MIN_V: { mappingName: 'vcc_min_V', formattedHeading: '' },
	IVCC_MAX_MA: { mappingName: 'ivcc_max_mA', formattedHeading: '' },
	IVCC_QUIESCENT_MAX_MA: { mappingName: 'ivcc_quiescent_max_mA', formattedHeading: '' },
	IVCC_STDBY_START__MAX_MA: { mappingName: 'ivcc_stdby_start__max_mA', formattedHeading: '' },
	VCC_PIN: { mappingName: 'vcc_pin', formattedHeading: '' },
	UVLO_START_THRESHOLD_V: { mappingName: 'uvlo_start_threshold_V', formattedHeading: '' },
	FSW_TYP_KHZ: { mappingName: 'fsw_typ_khz', formattedHeading: '' },
	FSW_MIN_KHZ: { mappingName: 'fsw_min_khz', formattedHeading: '' },
	FSW_MAX_KHZ: { mappingName: 'fsw_max_khz', formattedHeading: '' },
	D_MAX: { mappingName: 'd_max', formattedHeading: '' },
	TD_ON_MIN_NS: { mappingName: 'td_on_min_ns', formattedHeading: '' },
	TD_ON_MAX_NS: { mappingName: 'td_on_max_ns', formattedHeading: '' },
	TD_OFF_MIN_NS: { mappingName: 'td_off_min_ns', formattedHeading: '' },
	TD_OFF_MAX_NS: { mappingName: 'td_off_max_ns', formattedHeading: '' },
	I_OUT_A: { mappingName: 'i_out_A', formattedHeading: '' },
	OUTPUT_POWER_85_265_W: { mappingName: 'output_Power_85_265_W', formattedHeading: '' },
	OUTPUT_POWER_230_15_W: { mappingName: 'output_Power_230_15_W', formattedHeading: '' },
	VCS_MIN_V: { mappingName: 'vcs_min_V', formattedHeading: '' },
	ILIM_MIN_A: { mappingName: 'ilim_min_A', formattedHeading: '' },
	ILIM_TYP_A: { mappingName: 'ilim_typ_A', formattedHeading: '' },
	ILIM_MAX_A: { mappingName: 'ilim_max_A', formattedHeading: '' },
	OCP_TYPE: { mappingName: 'OCP_type', formattedHeading: '' },
	V_REF_V: { mappingName: 'v_ref_V', formattedHeading: '' },
	I_BIAS_MA: { mappingName: 'i_bias_mA', formattedHeading: '' },
	R_THJA_CW: { mappingName: 'r_thja_CW', formattedHeading: '' },
	R_THJC_CW: { mappingName: 'r_thjc_CW', formattedHeading: '' },
	TJ_MAX_CELSIUS: { mappingName: 'tj_max_Celsius', formattedHeading: '' },
	MIN_OP_TA_TC_CELSIUS: { mappingName: 'min_op_Ta_Tc_Celsius', formattedHeading: '' },
	MAX_OP_TA_TC_CELSIUS: { mappingName: 'max_op_Ta_Tc_Celsius', formattedHeading: '' },
	CONTROL_SCHEME: { mappingName: 'control_scheme', formattedHeading: '' },
	BUCK: { mappingName: 'buck', formattedHeading: '' },
	BOOST: { mappingName: 'boost', formattedHeading: '' },
	FLYBACK: { mappingName: 'flyback', formattedHeading: '' },
	QR_FLYBACK: { mappingName: 'qr_flyback', formattedHeading: '' },
	FSW_MAX_POWER_KHZ: { mappingName: 'fsw_Max_Power_kHz', formattedHeading: '' },
	EST_EFF: { mappingName: 'Est_Eff', formattedHeading: '' },
	TOTAL_CAP_UF: { mappingName: 'Total_Cap_uF', formattedHeading: '' },
	V_COMP_IPK_MIN_V: { mappingName: 'V_Comp_Ipk_Min_V', formattedHeading: '' },
	V_COMP_MIN_V: { mappingName: 'V_Comp_Min_V', formattedHeading: '' },
	V_COMP_MAX_V: { mappingName: 'V_Comp_Max_V', formattedHeading: '' },
	V_COMP_OFFSET_V: { mappingName: 'V_Comp_Offset_V', formattedHeading: '' },
	V_REF_CC_V: { mappingName: 'V_ref_CC_V', formattedHeading: '' },
	T_PROP_NS: { mappingName: 't_prop_ns', formattedHeading: '' },
	MANUFACTURER: { mappingName: 'manufacturer', formattedHeading: '' },
	COMMENTS: { mappingName: 'comments', formattedHeading: '' },
	PRODUCT_PAGE_URL: { mappingName: 'product_page_url', formattedHeading: '' },
	DATASHEET_FILE_NAME: { mappingName: 'datasheet_file_name', formattedHeading: '' },
	PRICE: { mappingName: 'price', formattedHeading: '' },
	MIN_ORDER: { mappingName: 'min_order', formattedHeading: '' },
	DESCRIPTION: { mappingName: 'description', formattedHeading: '' },
	PL_PREFERENCE: { mappingName: 'pl_preference', formattedHeading: '' },
	CONTROLLER: { mappingName: 'controller', formattedHeading: '' },
	REGULATOR: { mappingName: 'regulator', formattedHeading: '' },
	PSR: { mappingName: 'psr', formattedHeading: '' },
	SSR: { mappingName: 'ssr', formattedHeading: '' },
	BU: { mappingName: 'BU', formattedHeading: '' },
	GROUP_IDENTIFIER: { mappingName: 'group_identifier', formattedHeading: '' },
	PTI2: { mappingName: 'pti2', formattedHeading: '' },
	CONTACT: { mappingName: 'contact', formattedHeading: '' },
	WPN: { mappingName: 'wpn', formattedHeading: '' },
	ENABLED: { mappingName: 'enabled', formattedHeading: '' },
	STATUS: { mappingName: 'status', formattedHeading: '' },
	COMPLETED: { mappingName: 'completed', formattedHeading: '' },
	FAILED: { mappingName: 'failed', formattedHeading: '' },
	AUTO_QUALIFIED: { mappingName: 'auto_qualified', formattedHeading: '' },
	INPUT_VOLTAGE_UVLO_PIN: { mappingName: 'input_voltage_UVLO_pin', formattedHeading: '' },
	INPUT_VOLTAGE_OVLO_PIN: { mappingName: 'input_voltage_OVLO_pin', formattedHeading: '' },
	STANDBY_MOD: { mappingName: 'standby_mod', formattedHeading: '' },
	SCP: { mappingName: 'scp', formattedHeading: '' },
	OCP_SCP_FAULT_PROT_TYPE: { mappingName: 'ocp_scp_fault_prot_type', formattedHeading: '' },
	UVLO_OVLO_FAULT_PROT_TYPE: { mappingName: 'UVLO_OVLO_fault_prot_type', formattedHeading: '' },
	BROWN_OUT: { mappingName: 'brown_out', formattedHeading: '' },
	HV_STARTUP: { mappingName: 'hv_startup', formattedHeading: '' },
	SOFT_START_TIME_MS: { mappingName: 'soft_start_time_ms', formattedHeading: '' },
	SS_CURRENT_UA: { mappingName: 'ss_current_uA', formattedHeading: '' },
	OVER_POWER_COMP: { mappingName: 'over_power_comp', formattedHeading: '' },
	LIGHT_LOAD_EFF_ENHANCE: { mappingName: 'light_load_eff_enhance', formattedHeading: '' },
	INTEGRATED_MAIN_SWITCH_ONLY: { mappingName: 'integrated_main_switch_only', formattedHeading: '' },
	INTERNAL_COMP: { mappingName: 'internal_comp', formattedHeading: '' },
	EVB: { mappingName: 'EVB', formattedHeading: '' },
	SEC_REF_DESIGN: { mappingName: 'SEC_ref_design', formattedHeading: '' },
	SIMULATION_MODEL: { mappingName: 'simulation_model', formattedHeading: '' },
	PIN_COUNT: { mappingName: 'pin_count', formattedHeading: '' },
	OUPUT_OVP: { mappingName: 'ouput_OVP', formattedHeading: '' },
	ADJ_CURR_LIMIT: { mappingName: 'adj_curr_limit', formattedHeading: '' },
	SPREAD_SPECTRUM: { mappingName: 'spread_spectrum', formattedHeading: '' },
	LONG_DESCRIPTION: { mappingName: 'long_description', formattedHeading: '' },
	EVALUATION_BOARD_OPN: { mappingName: 'evaluation_board_opn', formattedHeading: '' },
	CASE_OUTLINE_FILE_NAME: { mappingName: 'case_outline_file_name', formattedHeading: '' }
};

export const BUCK_BOOST = {
	PART_NUMBER: { mappingName: 'part_number', formattedHeading: '' },
	RTM: { mappingName: 'rtm', formattedHeading: '' },
	INTG_SWITCH_TYPE: { mappingName: 'intg_switch_type', formattedHeading: '' },
	INTG_RECT_TYPE: { mappingName: 'intg_rect_type', formattedHeading: '' },
	VIN_MAX_V: { mappingName: 'vin_max_V', formattedHeading: '' },
	VIN_MIN_V: { mappingName: 'vin_min_V', formattedHeading: '' },
	VSW_MAX_V: { mappingName: 'vsw_max_V', formattedHeading: '' },
	VCC_MAX_V: { mappingName: 'vcc_max_V', formattedHeading: '' },
	VCC_MIN_V: { mappingName: 'vcc_min_V', formattedHeading: '' },
	VOUT_V: { mappingName: 'vout_V', formattedHeading: '' },
	DIGITAL_VOUT: { mappingName: 'digital_vout', formattedHeading: '' },
	UVLO_START_THRESHOLD_V: { mappingName: 'uvlo_start_threshold_V', formattedHeading: '' },
	FSW_TYP_KHZ: { mappingName: 'fsw_typ_khz', formattedHeading: '' },
	FSW_MIN_KHZ: { mappingName: 'fsw_min_khz', formattedHeading: '' },
	FSW_MAX_KHZ: { mappingName: 'fsw_max_khz', formattedHeading: '' },
	D_MAX: { mappingName: 'd_max', formattedHeading: '' },
	TON_MIN_NS: { mappingName: 'ton_min_ns', formattedHeading: '' },
	TON_MAX_US: { mappingName: 'ton_max_us', formattedHeading: '' },
	TOFF_MIN_NS: { mappingName: 'toff_min_ns', formattedHeading: '' },
	I_OUT_A: { mappingName: 'i_out_A', formattedHeading: '' },
	ILIM_TYP_A: { mappingName: 'ilim_typ_A', formattedHeading: '' },
	ILIM_MIN_A: { mappingName: 'ilim_min_A', formattedHeading: '' },
	V_REF_V: { mappingName: 'v_ref_V', formattedHeading: '' },
	V_CL_V: { mappingName: 'v_cl_V', formattedHeading: '' },
	I_BIAS_MA: { mappingName: 'i_bias_mA', formattedHeading: '' },
	R_THJA_CW: { mappingName: 'r_thja_CW', formattedHeading: '' },
	R_THJC_CW: { mappingName: 'r_thjc_CW', formattedHeading: '' },
	TJ_MAX_CELSIUS: { mappingName: 'tj_max_Celsius', formattedHeading: '' },
	MIN_OP_TA_TC_CELSIUS: { mappingName: 'min_op_Ta_Tc_Celsius', formattedHeading: '' },
	MAX_OP_TA_TC_CELSIUS: { mappingName: 'max_op_Ta_Tc_Celsius', formattedHeading: '' },
	SYNC_RECT: { mappingName: 'sync_rect', formattedHeading: '' },
	CONTROL_SCHEME: { mappingName: 'control_scheme', formattedHeading: '' },
	BUCK: { mappingName: 'buck', formattedHeading: '' },
	BOOST: { mappingName: 'boost', formattedHeading: '' },
	FLYBACK: { mappingName: 'flyback', formattedHeading: '' },
	QR_FLYBACK: { mappingName: 'qr_flyback', formattedHeading: '' },
	FSW_MAX_POWER_KHZ: { mappingName: 'fsw_Max_Power_kHz', formattedHeading: '' },
	EST_EFF: { mappingName: 'Est_Eff', formattedHeading: '' },
	TOTAL_CAP_UF: { mappingName: 'Total_Cap_uF', formattedHeading: '' },
	V_COMP_IPK_MIN_V: { mappingName: 'V_Comp_Ipk_Min_V', formattedHeading: '' },
	V_COMP_MIN_V: { mappingName: 'V_Comp_Min_V', formattedHeading: '' },
	V_COMP_MAX_V: { mappingName: 'V_Comp_Max_V', formattedHeading: '' },
	V_COMP_OFFSET_V: { mappingName: 'V_Comp_Offset_V', formattedHeading: '' },
	V_REF_CC_V: { mappingName: 'V_ref_CC_V', formattedHeading: '' },
	T_PROP_NS: { mappingName: 't_prop_ns', formattedHeading: '' },
	MANUFACTURER: { mappingName: 'manufacturer', formattedHeading: '' },
	PRODUCT_PAGE_URL: { mappingName: 'product_page_url', formattedHeading: '' },
	DATASHEET_FILE_NAME: { mappingName: 'datasheet_file_name', formattedHeading: '' },
	PM_BUS: { mappingName: 'pm_bus', formattedHeading: '' },
	EXTERNAL_CLOCK: { mappingName: 'external_clock', formattedHeading: '' },
	ADJ_CURR_LIMIT: { mappingName: 'adj_curr_limit', formattedHeading: '' },
	SPREAD_SPECTRUM: { mappingName: 'spread_spectrum', formattedHeading: '' },
	FORCED_PWM: { mappingName: 'forced_pwm', formattedHeading: '' },
	BOOST_TRUE_DISCON: { mappingName: 'boost_true_discon', formattedHeading: '' },
	BOOST_BYPASS_MODE: { mappingName: 'boost_bypass_mode', formattedHeading: '' },
	BOOST_PASS_THRU_MODE: { mappingName: 'boost_pass_thru_mode', formattedHeading: '' },
	PRICE: { mappingName: 'price', formattedHeading: '' },
	MIN_ORDER: { mappingName: 'min_order', formattedHeading: '' },
	DESCRIPTION: { mappingName: 'description', formattedHeading: '' },
	AUTO_QUALIFIED: { mappingName: 'auto_qualified', formattedHeading: '' },
	POWER_GOOD_INDICATOR_PIN: { mappingName: 'power_good_indicator_pin', formattedHeading: '' },
	INPUT_VOLTAGE_UVLO_PIN: { mappingName: 'input_voltage_UVLO_pin', formattedHeading: '' },
	INPUT_VOLTAGE_OVLO_PIN: { mappingName: 'input_voltage_OVLO_pin', formattedHeading: '' },
	ENABLE_PIN: { mappingName: 'enable_pin', formattedHeading: '' },
	STANDBY_MOD: { mappingName: 'standby_mod', formattedHeading: '' },
	SCP: { mappingName: 'scp', formattedHeading: '' },
	OCP_SCP_FAULT_PROT_TYPE: { mappingName: 'ocp_scp_fault_prot_type', formattedHeading: '' },
	UVLO_OVLO_FAULT_PROT_TYPE: { mappingName: 'UVLO_OVLO_fault_prot_type', formattedHeading: '' },
	HV_STARTUP: { mappingName: 'hv_startup', formattedHeading: '' },
	SOFT_START: { mappingName: 'soft_start', formattedHeading: '' },
	CLOCK_SYNC_PIN: { mappingName: 'clock_sync_pin', formattedHeading: '' },
	LIGHT_LOAD_EFF_ENHANCE: { mappingName: 'light_load_eff_enhance', formattedHeading: '' },
	INTEGRATED_MAIN_SWITCH_ONLY: { mappingName: 'integrated_main_switch_only', formattedHeading: '' },
	INTEGRATED_MAIN_SWITCH_RECT: { mappingName: 'integrated_main_switch_rect', formattedHeading: '' },
	MAIN_SWITCH_RDSON_TYP_MOHM: { mappingName: 'main_switch_Rdson_typ_mohm', formattedHeading: '' },
	SR_RDSON_TYP_MOHM: { mappingName: 'sr_Rdson_typ_mohm', formattedHeading: '' },
	INTERNAL_COMP: { mappingName: 'internal_comp', formattedHeading: '' },
	RECT_TYPE_SR_DIODE: { mappingName: 'rect_type_sr_diode', formattedHeading: '' },
	EVB: { mappingName: 'EVB', formattedHeading: '' },
	SEC_REF_DESIGN: { mappingName: 'SEC_ref_design', formattedHeading: '' },
	PIN_COUNT: { mappingName: 'pin_count', formattedHeading: '' },
	IC_SIMULATION_MODE: { mappingName: 'ic_simulation_mode', formattedHeading: '' },
	COMMENTS: { mappingName: 'comments', formattedHeading: '' },
	PL_PREFERENCE: { mappingName: 'pl_preference', formattedHeading: '' },
	CONTROLLER: { mappingName: 'controller', formattedHeading: '' },
	REGULATOR: { mappingName: 'regulator', formattedHeading: '' },
	CONVERTER: { mappingName: 'converter', formattedHeading: '' },
	BU: { mappingName: 'BU', formattedHeading: '' },
	GROUP_IDENTIFIER: { mappingName: 'group_identifier', formattedHeading: '' },
	PTI2: { mappingName: 'pti2', formattedHeading: '' },
	CONTACT: { mappingName: 'contact', formattedHeading: '' },
	WPN: { mappingName: 'wpn', formattedHeading: '' },
	MULTI_PHASE: { mappingName: 'multi_phase', formattedHeading: '' },
	OUPUT_OVP: { mappingName: 'ouput_ovp', formattedHeading: '' },
	RTHJ_PCB_CW: { mappingName: 'rthj_pcb_cw', formattedHeading: '' },
	I_OUT_MAX1_A: { mappingName: 'i_out_max1_A', formattedHeading: '' },
	I_OUT_MAX1_AT_V_IN1_V: { mappingName: 'i_out_max1_at_v_in1_V', formattedHeading: '' },
	I_OUT_MAX2_A: { mappingName: 'i_out_max2_A', formattedHeading: '' },
	I_OUT_MAX1_AT_V_IN2_V: { mappingName: 'i_out_max1_at_v_in2_V', formattedHeading: '' },
	I_OUT_MAX3_A: { mappingName: 'i_out_max3_A', formattedHeading: '' },
	I_OUT_MAX1_AT_V_IN3_V: { mappingName: 'i_out_max1_at_v_in3_V', formattedHeading: '' },
	I_OUT_MAX4_A: { mappingName: 'i_out_max4_A', formattedHeading: '' },
	I_OUT_MAX1_AT_V_IN4_V: { mappingName: 'i_out_max1_at_v_in4_V', formattedHeading: '' },
	ENABLED: { mappingName: 'enabled', formattedHeading: '' },
	STATUS: { mappingName: 'status', formattedHeading: '' },
	COMPLETED: { mappingName: 'completed', formattedHeading: '' },
	LONG_DESCRIPTION: { mappingName: 'long_description', formattedHeading: '' },
	EVALUATION_BOARD_OPN: { mappingName: 'evaluation_board_opn', formattedHeading: '' },
	CASE_OUTLINE_FILE_NAME: { mappingName: 'case_outline_file_name', formattedHeading: '' }
};

export const CHARGE_PUMP = {
	PART_NUMBER: { mappingName: 'part_number', formattedHeading: '' },
	WPN: { mappingName: 'wpn', formattedHeading: '' },
	CATEGORY: { mappingName: 'category', formattedHeading: '' },
	RTM: { mappingName: 'rtm', formattedHeading: '' },
	VOUT_V: { mappingName: 'vout_V', formattedHeading: '' },
	VOUT_MIN_V: { mappingName: 'vout_min_V', formattedHeading: '' },
	VOUT_MAX_V: { mappingName: 'vout_max_V', formattedHeading: '' },
	VIN_MIN_V: { mappingName: 'vin_min_V', formattedHeading: '' },
	VIN_MAX_V: { mappingName: 'vin_max_V', formattedHeading: '' },
	IOUT_TYP_A: { mappingName: 'iout_typ_A', formattedHeading: '' },
	IQ_TYP_MA: { mappingName: 'iq_typ_mA', formattedHeading: '' },
	IQ_TYP01_MA: { mappingName: 'iq_typ01_mA', formattedHeading: '' },
	VREF_TYP_V: { mappingName: 'vref_typ_V', formattedHeading: '' },
	VTH_PS_V: { mappingName: 'vth_ps_V', formattedHeading: '' },
	COUT_REC: { mappingName: 'cout_rec', formattedHeading: '' },
	FSW_TYP: { mappingName: 'fsw_typ', formattedHeading: '' },
	RTHJA_CW: { mappingName: 'rthja_CW', formattedHeading: '' },
	RTHJC_CW: { mappingName: 'rthjc_CW', formattedHeading: '' },
	T_MAX_C: { mappingName: 't_max_C', formattedHeading: '' },
	T_OPR_MAX_C: { mappingName: 't_opr_max_C', formattedHeading: '' },
	T_OPR_MIN_C: { mappingName: 't_opr_min_C', formattedHeading: '' },
	PRODUCT_PAGE_URL: { mappingName: 'product_page_url', formattedHeading: '' },
	DATASHEET_FILE_NAME: { mappingName: 'datasheet_file_name', formattedHeading: '' },
	ENABLE: { mappingName: 'enable', formattedHeading: '' },
	AUTO_APP: { mappingName: 'auto_app', formattedHeading: '' },
	IOUT_MAX_A: { mappingName: 'iout_max_A', formattedHeading: '' },
	IOUT_MIN_A: { mappingName: 'iout_min_A', formattedHeading: '' },
	RSW_SCC: { mappingName: 'rsw_scc', formattedHeading: '' },
	RSW_VIN5V: { mappingName: 'RSW_VIN5V', formattedHeading: '' },
	RSW_VIN3V3: { mappingName: 'RSW_VIN3V3', formattedHeading: '' },
	RSW_VIN2V0: { mappingName: 'RSW_VIN2V0', formattedHeading: '' },
	RSW_VIN1V5: { mappingName: 'RSW_VIN1V5', formattedHeading: '' },
	TCO_VIN5V: { mappingName: 'TCO_VIN5V', formattedHeading: '' },
	TCO_VIN3V3: { mappingName: 'TCO_VIN3V3', formattedHeading: '' },
	TCO_VIN2V0: { mappingName: 'TCO_VIN2V0', formattedHeading: '' },
	TCO_VIN1V5: { mappingName: 'TCO_VIN1V5', formattedHeading: '' },
	VEN_THRHD_HIGH_V: { mappingName: 'ven_thrhd_high_V', formattedHeading: '' },
	VEN_THRHD_LOW_V: { mappingName: 'ven_thrhd_low_V', formattedHeading: '' },
	DESCRIPTION: { mappingName: 'description', formattedHeading: '' },
	PASS_THROUGH: { mappingName: 'pass_through', formattedHeading: '' },
	PM_BUS: { mappingName: 'pm_bus', formattedHeading: '' },
	PRICE: { mappingName: 'price', formattedHeading: '' },
	MIN_ORDER: { mappingName: 'min_order', formattedHeading: '' },
	ENABLED: { mappingName: 'enabled', formattedHeading: '' },
	STATUS: { mappingName: 'status', formattedHeading: '' },
	COMPLETED: { mappingName: 'completed', formattedHeading: '' },
	LONG_DESCRIPTION: { mappingName: 'long_description', formattedHeading: '' },
	EVALUATION_BOARD_OPN: { mappingName: 'evaluation_board_opn', formattedHeading: '' },
	CASE_OUTLINE_FILE_NAME: { mappingName: 'case_outline_file_name', formattedHeading: '' }
};

export const MOSFET = {
	PART_NUMBER: { mappingName: 'part_number', formattedHeading: '' },
	WPN: { mappingName: 'wpn', formattedHeading: '' },
	DIGI_KEY: { mappingName: 'digi_key', formattedHeading: '' },
	MOUSER: { mappingName: 'mouser', formattedHeading: '' },
	PRICE: { mappingName: 'price', formattedHeading: '' },
	PACKAGING: { mappingName: 'packaging', formattedHeading: '' },
	DATASHEET_FILE_NAME: { mappingName: 'datasheet_file_name', formattedHeading: '' },
	PRODUCT_PAGE_FORMULA: { mappingName: 'product_page_formula', formattedHeading: '' },
	PRODUCT_PAGE_NO_FORMULA: { mappingName: 'product_page_no_formula', formattedHeading: '' },
	BVDSS: { mappingName: 'bvdss', formattedHeading: '' },
	VGS_MAX_V: { mappingName: 'vgs_max_V', formattedHeading: '' },
	ID_CONT_TA25: { mappingName: 'id_cont_ta25', formattedHeading: '' },
	ID_CONT_TC25: { mappingName: 'id_cont_tc25', formattedHeading: '' },
	VGS_V: { mappingName: 'vgs_V', formattedHeading: '' },
	RDS_ON_MAX_M_OHM: { mappingName: 'rds_on_max_m_ohm', formattedHeading: '' },
	RDS_ON_MAX_VGS4_5_M_OHM: { mappingName: 'rds_on_max_vgs4_5_m_ohm', formattedHeading: '' },
	QGS_TYP_NC: { mappingName: 'qgs_typ_nc', formattedHeading: '' },
	QGD_TYP_NC: { mappingName: 'qgd_typ_nC', formattedHeading: '' },
	CISS_PF: { mappingName: 'ciss_pF', formattedHeading: '' },
	COSS_MAX_PF: { mappingName: 'coss_max_pF', formattedHeading: '' },
	R_THJA_CELSIUSATW: { mappingName: 'r_thja_CelsiusAtW', formattedHeading: '' },
	R_THJC_CELSIUSATW: { mappingName: 'r_thjc_CelsiusAtW', formattedHeading: '' },
	TJ_MAX_CELSIUS: { mappingName: 'tj_max_Celsius', formattedHeading: '' },
	VGSTH_V: { mappingName: 'vgsth_V', formattedHeading: '' },
	GFS_TYP_S: { mappingName: 'gfs_typ_S', formattedHeading: '' },
	RG_TYP_OHM: { mappingName: 'rg_typ_ohm', formattedHeading: '' },
	QG_TOT_TYP_VGS10_NC: { mappingName: 'qg_tot_typ_vgs10_nC', formattedHeading: '' },
	QG_TOT_TYP_VGS8_NC: { mappingName: 'qg_tot_typ_vgs8_nC', formattedHeading: '' },
	QG_TOT_TYP_VGS6_NC: { mappingName: 'qg_tot_typ_vgs6_nC', formattedHeading: '' },
	QG_TOT_TYP_VGS5_NC: { mappingName: 'qg_tot_typ_vgs5_nC', formattedHeading: '' },
	QG_TOT_TYP_VGS4_5_NC: { mappingName: 'qg_tot_typ_vgs4_5_nC', formattedHeading: '' },
	QG_TOT_TYP_VGS2_5_NC: { mappingName: 'qg_tot_typ_vgs2_5_nC', formattedHeading: '' },
	QG_TOT_TYP_VGS2_NC: { mappingName: 'qg_tot_typ_vgs2_nC', formattedHeading: '' },
	VSD_TYP_ID_MAX_V: { mappingName: 'vsd_typ_id_max_V', formattedHeading: '' },
	QRR_TYP_NC: { mappingName: 'qrr_typ_nC', formattedHeading: '' },
	RDS_ON_MAX_VGS8_M_OHM: { mappingName: 'rds_on_max_vgs8_m_ohm', formattedHeading: '' },
	RDS_ON_MAX_VGS7_M_OHM: { mappingName: 'rds_on_max_vgs7_m_ohm', formattedHeading: '' },
	RDS_ON_MAX_VGS6_M_OHM: { mappingName: 'rds_on_max_vgs6_m_ohm', formattedHeading: '' },
	RDS_ON_MAX_VGS5_M_OHM: { mappingName: 'rds_on_max_vgs5_m_ohm', formattedHeading: '' },
	RDS_ON_MAX_VGS2_7_M_OHM: { mappingName: 'rds_on_max_vgs2_7_m_ohm', formattedHeading: '' },
	RDS_ON_MAX_VGS2_5_M_OHM: { mappingName: 'rds_on_max_vgs2_5_m_ohm', formattedHeading: '' },
	RDS_ON_MAX_VGS2_M_OHM: { mappingName: 'rds_on_max_vgs2_m_ohm', formattedHeading: '' },
	RDS_ON_MAX_VGS1_8_M_OHM: { mappingName: 'rds_on_max_vgs1_8_m_ohm', formattedHeading: '' },
	RDS_ON_MAX_VGS1_5_M_OHM: { mappingName: 'rds_on_max_vgs1_5_m_ohm', formattedHeading: '' },
	COSS_TYP_PF: { mappingName: 'coss_typ_pF', formattedHeading: '' },
	QRR_TYP_300A_US_NC: { mappingName: 'qrr_typ_300a_us_nC', formattedHeading: '' },
	MANUFACTURER: { mappingName: 'manufacturer', formattedHeading: '' },
	ENABLED: { mappingName: 'enabled', formattedHeading: '' },
	STATUS: { mappingName: 'status', formattedHeading: '' },
	COMPLETED: { mappingName: 'completed', formattedHeading: '' },
	LONG_DESCRIPTION: { mappingName: 'long_description', formattedHeading: '' },
	EVALUATION_BOARDS_FOR_WPN: { mappingName: 'evaluation_boards_for_wpn', formattedHeading: '' },
	CASE_OUTLINE_FILE_NAME: { mappingName: 'case_outline_file_name', formattedHeading: '' }
};

export const DIODE = {
	PART_NUMBER: { mappingName: 'part_number', formattedHeading: '' },
	WPN: { mappingName: 'wpn', formattedHeading: '' },
	DIGI_KEY: { mappingName: 'digi_key', formattedHeading: '' },
	MOUSER: { mappingName: 'mouser', formattedHeading: '' },
	PACKAGING: { mappingName: 'packaging', formattedHeading: '' },
	KFACTOR: { mappingName: 'kfactor', formattedHeading: '' },
	NFACTOR: { mappingName: 'nfactor', formattedHeading: '' },
	I_S_A: { mappingName: 'i_s_A', formattedHeading: '' },
	VJ_0P1IFAV_V: { mappingName: 'vj_0p1ifav_V', formattedHeading: '' },
	VJ_IFAV_V: { mappingName: 'vj_ifav_V', formattedHeading: '' },
	VJ_2IFAV_V: { mappingName: 'vj_2ifav_V', formattedHeading: '' },
	I_REV_S_UA: { mappingName: 'i_rev_s_uA', formattedHeading: '' },
	BFACTOR: { mappingName: 'bfactor', formattedHeading: '' },
	IREV_VRRM_125C_UA: { mappingName: 'irev_vrrm_125c_uA', formattedHeading: '' },
	ZERO_P7VRRM_125C_: { mappingName: 'zero_p7vrrm_125c_uA', formattedHeading: '' },
	IREV_0P7VRRM_25C_: { mappingName: 'irev_0p7vrrm_25c_uA', formattedHeading: '' },
	PRICE: { mappingName: 'price', formattedHeading: '' },
	VRRM_V: { mappingName: 'vrrm_V', formattedHeading: '' },
	I_FAV_A: { mappingName: 'i_fav_A', formattedHeading: '' },
	I_FSM_A: { mappingName: 'i_fsm_A', formattedHeading: '' },
	VF_MAX_V: { mappingName: 'vf_max_V', formattedHeading: '' },
	AT_A: { mappingName: 'at_A', formattedHeading: '' },
	TRR_TYP_NS: { mappingName: 'trr_typ_ns', formattedHeading: '' },
	QRR_TYP_NC: { mappingName: 'qrr_typ_nC', formattedHeading: '' },
	IR_MAX_25C_UA: { mappingName: 'ir_max_25c_uA', formattedHeading: '' },
	C_TOT_TYP_PF: { mappingName: 'c_tot_typ_pF', formattedHeading: '' },
	R_THJA_CELSIUSWAT: { mappingName: 'r_thja_celsiuswatt', formattedHeading: '' },
	R_THJC_CELSIUSWAT: { mappingName: 'r_thjc_celsiuswatt', formattedHeading: '' },
	R_THJL_CELSIUSWAT: { mappingName: 'r_thjl_celsiuswatt', formattedHeading: '' },
	TJ_MAX_CELSIUS: { mappingName: 'tj_max_celsius', formattedHeading: '' },
	TYPE: { mappingName: 'type', formattedHeading: '' },
	CONFIGURATION: { mappingName: 'configuration', formattedHeading: '' },
	MANUFACTURER: { mappingName: 'manufacturer', formattedHeading: '' },
	VF_0_001A_25C_V: { mappingName: 'vf_0_001a_25c_V', formattedHeading: '' },
	VF_0_01A_25C_V: { mappingName: 'vf_0_01a_25c_V', formattedHeading: '' },
	VF_0_1A_25C_V: { mappingName: 'vf_0_1a_25c_V', formattedHeading: '' },
	VF_0_2A_25C_V: { mappingName: 'vf_0_2a_25c_V', formattedHeading: '' },
	VF_0_5A_25C_V: { mappingName: 'vf_0_5a_25c_V', formattedHeading: '' },
	VF_1A_25C_V: { mappingName: 'vf_1a_25c_V', formattedHeading: '' },
	VF_2A_25C_V: { mappingName: 'vf_2a_25c_V', formattedHeading: '' },
	VF_5A_25C_V: { mappingName: 'vf_5a_25c_V', formattedHeading: '' },
	VF_10A_25C_V: { mappingName: 'vf_10a_25c_V', formattedHeading: '' },
	VF_30A_25C_V: { mappingName: 'vf_30a_25c_V', formattedHeading: '' },
	VF_50A_25C_V: { mappingName: 'vf_50a_25c_V', formattedHeading: '' },
	VF_0_001A_100C_V: { mappingName: 'vf_0_001a_100c_V', formattedHeading: '' },
	VF_0_01A_100C_V: { mappingName: 'vf_0_01a_100c_V', formattedHeading: '' },
	VF_0_1A_100C_V: { mappingName: 'vf_0_1a_100c_V', formattedHeading: '' },
	VF_0_2A_100C_V: { mappingName: 'vf_0_2a_100c_V', formattedHeading: '' },
	VF_0_5A_100C_V: { mappingName: 'vf_0_5a_100c_V', formattedHeading: '' },
	VF_1A_100C_V: { mappingName: 'vf_1a_100c_V', formattedHeading: '' },
	VF_2A_100C_V: { mappingName: 'vf_2a_100c_V', formattedHeading: '' },
	VF_5A_100C_V: { mappingName: 'vf_5a_100c_V', formattedHeading: '' },
	VF_10A_100C_V: { mappingName: 'vf_10a_100c_V', formattedHeading: '' },
	VF_30A_100C_V: { mappingName: 'vf_30a_100c_V', formattedHeading: '' },
	VF_50A_100C_V: { mappingName: 'vf_50a_100c_V', formattedHeading: '' },
	VF_0_001A_125C_V: { mappingName: 'vf_0_001a_125c_V', formattedHeading: '' },
	VF_0_01A_125C_V: { mappingName: 'vf_0_01a_125c_V', formattedHeading: '' },
	VF_0_1A_125C_V: { mappingName: 'vf_0_1a_125c_V', formattedHeading: '' },
	VF_0_2A_125C_V: { mappingName: 'vf_0_2a_125c_V', formattedHeading: '' },
	VF_0_5A_125C_V: { mappingName: 'vf_0_5a_125c_V', formattedHeading: '' },
	VF_1A_125C_V: { mappingName: 'vf_1a_125c_V', formattedHeading: '' },
	VF_2A_125C_V: { mappingName: 'vf_2a_125c_V', formattedHeading: '' },
	VF_5A_125C_V: { mappingName: 'vf_5a_125c_V', formattedHeading: '' },
	VF_10A_125C_V: { mappingName: 'vf_10a_125c_V', formattedHeading: '' },
	VF_30A_125C_V: { mappingName: 'vf_30a_125c_V', formattedHeading: '' },
	VF_50A_125C_V: { mappingName: 'vf_50a_125c_V', formattedHeading: '' },
	VF_0_001A_150C_V: { mappingName: 'vf_0_001a_150c_V', formattedHeading: '' },
	VF_0_01A_150C_V: { mappingName: 'vf_0_01a_150c_V', formattedHeading: '' },
	VF_0_1A_150C_V: { mappingName: 'vf_0_1a_150c_V', formattedHeading: '' },
	VF_0_2A_150C_V: { mappingName: 'vf_0_2a_150c_V', formattedHeading: '' },
	VF_0_5A_150C_V: { mappingName: 'vf_0_5a_150c_V', formattedHeading: '' },
	VF_1A_150C_V: { mappingName: 'vf_1a_150c_V', formattedHeading: '' },
	VF_2A_150C_V: { mappingName: 'vf_2a_150c_V', formattedHeading: '' },
	VF_5A_150C_V: { mappingName: 'vf_5a_150c_V', formattedHeading: '' },
	VF_10A_150C_V: { mappingName: 'vf_10a_150c_V', formattedHeading: '' },
	VF_30A_150C_V: { mappingName: 'vf_30a_150c_V', formattedHeading: '' },
	VF_50A_150C_V: { mappingName: 'vf_50a_150c_V', formattedHeading: '' },
	VF_0_001A_175C_V: { mappingName: 'vf_0_001a_175c_V', formattedHeading: '' },
	VF_0_01A_175C_V: { mappingName: 'vf_0_01a_175c_V', formattedHeading: '' },
	VF_0_1A_175C_V: { mappingName: 'vf_0_1a_175c_V', formattedHeading: '' },
	VF_0_2A_175C_V: { mappingName: 'vf_0_2a_175c_V', formattedHeading: '' },
	VF_0_5A_175C_V: { mappingName: 'vf_0_5a_175c_V', formattedHeading: '' },
	VF_1A_175C_V: { mappingName: 'vf_1a_175c_V', formattedHeading: '' },
	VF_2A_175C_V: { mappingName: 'vf_2a_175c_V', formattedHeading: '' },
	VF_5A_175C_V: { mappingName: 'vf_5a_175c_V', formattedHeading: '' },
	VF_10A_175C_V: { mappingName: 'vf_10a_175c_V', formattedHeading: '' },
	VF_30A_175C_V: { mappingName: 'vf_30a_175c_V', formattedHeading: '' },
	VF_50A_175C_V: { mappingName: 'vf_50a_175c_V', formattedHeading: '' },
	C_TOT_VR_2_PF: { mappingName: 'c_tot_vr_2_pF', formattedHeading: '' },
	IR_20_VRM_25C_UA: { mappingName: 'ir_20_vrm_25c_uA', formattedHeading: '' },
	IR_40_VRM_25C_UA: { mappingName: 'ir_40_vrm_25c_uA', formattedHeading: '' },
	IR_60_VRM_25C_UA: { mappingName: 'ir_60_vrm_25c_uA', formattedHeading: '' },
	IR_80_VRM_25C_UA: { mappingName: 'ir_80_vrm_25c_uA', formattedHeading: '' },
	IR_100_VRM_25C_UA: { mappingName: 'ir_100_vrm_25c_uA', formattedHeading: '' },
	IR_20_VRM_100C_UA: { mappingName: 'ir_20_vrm_100c_uA', formattedHeading: '' },
	IR_40_VRM_100C_UA: { mappingName: 'ir_40_vrm_100c_uA', formattedHeading: '' },
	IR_60_VRM_100C_UA: { mappingName: 'ir_60_vrm_100c_uA', formattedHeading: '' },
	IR_80_VRM_100C_UA: { mappingName: 'ir_80_vrm_100c_uA', formattedHeading: '' },
	IR_100_VRM_100C_U: { mappingName: 'ir_100_vrm_100c_uA', formattedHeading: '' },
	IR_20_VRM_125C_UA: { mappingName: 'ir_20_vrm_125c_uA', formattedHeading: '' },
	IR_40_VRM_125C_UA: { mappingName: 'ir_40_vrm_125c_uA', formattedHeading: '' },
	IR_60_VRM_125C_UA: { mappingName: 'ir_60_vrm_125c_uA', formattedHeading: '' },
	IR_80_VRM_125C_UA: { mappingName: 'ir_80_vrm_125c_uA', formattedHeading: '' },
	IR_100_VRM_125C_U: { mappingName: 'ir_100_vrm_125c_uA', formattedHeading: '' },
	IR_20_VRM_150C_UA: { mappingName: 'ir_20_vrm_150c_uA', formattedHeading: '' },
	IR_40_VRM_150C_UA: { mappingName: 'ir_40_vrm_150c_uA', formattedHeading: '' },
	IR_60_VRM_150C_UA: { mappingName: 'ir_60_vrm_150c_uA', formattedHeading: '' },
	IR_80_VRM_150C_UA: { mappingName: 'ir_80_vrm_150c_uA', formattedHeading: '' },
	IR_100_VRM_150C_U: { mappingName: 'ir_100_vrm_150c_uA', formattedHeading: '' },
	IR_20_VRM_175C_UA: { mappingName: 'ir_20_vrm_175c_uA', formattedHeading: '' },
	IR_40_VRM_175C_UA: { mappingName: 'ir_40_vrm_175c_uA', formattedHeading: '' },
	IR_60_VRM_175C_UA: { mappingName: 'ir_60_vrm_175c_uA', formattedHeading: '' },
	IR_80_VRM_175C_UA: { mappingName: 'ir_80_vrm_175c_uA', formattedHeading: '' },
	IR_100_VRM_175C_U: { mappingName: 'ir_100_vrm_175c_uA', formattedHeading: '' },
	IRM_A: { mappingName: 'irm_A', formattedHeading: '' },
	DATASHEET_FILE_NA: { mappingName: 'datasheet_file_name', formattedHeading: '' },
	PRODUCT_PAGE_FORM: { mappingName: 'product_page_formula', formattedHeading: '' },
	PRODUCT_PAGE_NO_F: { mappingName: 'product_page_no_formula', formattedHeading: '' },
	ENABLED: { mappingName: 'enabled', formattedHeading: '' },
	STATUS: { mappingName: 'status', formattedHeading: '' },
	COMPLETED: { mappingName: 'completed', formattedHeading: '' },
	LONG_DESCRIPTION: { mappingName: 'long_description', formattedHeading: '' },
	EVALUATION_BOARDS: { mappingName: 'evaluation_boards_for_wpn', formattedHeading: '' },
	CASE_OUTLINE_FILE: { mappingName: 'case_outline_file_name', formattedHeading: '' }
};
